import type { VoiceInfo } from "../types/guide";

// The Gemini Live voice picker (tts.liveVoiceId, required to publish). The
// allowed set comes from GET /studio/guides/voices (liveVoices).

/** The guide's gender, read from the first of its voices the catalog knows. */
export function guideGender(voices: VoiceInfo[], voiceIds: (string | null | undefined)[]): string {
  for (const id of voiceIds) {
    const gender = id ? voices.find((v) => v.voiceId === id)?.gender : "";
    if (gender) return gender;
  }
  return "";
}

/** Live-allowed Gemini voices, the guide's gender first, then by name. */
export function liveVoiceOptions(gemini: VoiceInfo[], allowed: string[], gender: string): VoiceInfo[] {
  const allowedSet = new Set(allowed);
  const rank = (v: VoiceInfo) => (gender && v.gender === gender ? 0 : 1);
  return gemini
    .filter((v) => allowedSet.has(v.voiceId))
    .sort((a, b) => rank(a) - rank(b) || a.name.localeCompare(b.name));
}

/** Why the guide's Live voice can't publish, or "" when it can. */
export function liveVoiceError(liveVoice: string | null | undefined, allowed: string[]): string {
  if (!liveVoice) return "Pick a Gemini Live voice: it is required to publish.";
  if (allowed.length && !allowed.includes(liveVoice)) return `${liveVoice} is not allowed on Live. Pick another voice.`;
  return "";
}
